import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { APP_VERSION } from '../services/geoService';

const { FiHeart } = FiIcons;

const Footer = () => {
  return (
    <footer className="mt-20 border-t-2 border-slate-100 pt-16 pb-12 px-6 text-center">
      <div className="flex flex-col items-center gap-8">
        <div className="space-y-4">
          <a
            href="https://NearMe.ph"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block hover:opacity-80 transition-opacity"
          >
            <h2 className="text-2xl font-black text-slate-950 tracking-tighter">
              📍 NearMe <span className="text-indigo-600">Search</span>
            </h2>
          </a>
          <p className="text-slate-800 text-sm font-medium leading-relaxed max-w-sm mx-auto">
            <span className="font-black">Discover Local</span> — Your high-contrast local directory for essential services near you.
          </p>
        </div>

        <div className="w-full pt-8 border-t border-slate-100 flex flex-col items-center gap-4">
          <p className="text-[10px] font-black text-slate-950 uppercase tracking-[0.3em] flex items-center gap-2">
            Made with <SafeIcon icon={FiHeart} className="text-rose-600 animate-pulse" /> in PH
          </p>
          <div className="flex flex-col items-center gap-2">
            <a
              href="https://NearMe.ph"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[10px] text-slate-700 font-black uppercase tracking-widest hover:text-indigo-600 transition-colors"
            >
              © {new Date().getFullYear()} NearMe Search • NearMe.ph
            </a>
            <span className="text-[8px] font-black text-slate-400 uppercase tracking-[0.4em] bg-slate-50 px-3 py-1 rounded-full border border-slate-100">
              Build v{APP_VERSION}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;